import * as React from 'react';

import cn from 'classnames';

import { BrandDownloadPanel } from '../BrandDownloadPanel';

import { IBrandBlockProps, IBrandBlockState } from './types';

import * as s from './BrandBlock.scss';

export class BrandBlock extends React.Component<IBrandBlockProps, IBrandBlockState> {

	render() {
		const {
			title,
			downloadTitle,
			downloadLinkUrl,
			downloadFileSize,
			hasBottomDownloadPanel = false,
			classNames: {
				block: blockClassName,
				header: headerClassName,
				title: titleClassName,
				content: contentClassName,
			} = {},
			onDownloadButtonClick,
			children,
		} = this.props;

		const isVisible = {
			topDownloadPanel: !hasBottomDownloadPanel,
			bottomDownloadPanel: hasBottomDownloadPanel,
		};

		return (
			<div className={cn(s.block, blockClassName)}>
				<div className={cn(s.header, headerClassName)}>
					<div className={cn(s.title, titleClassName)}>
						{title}
					</div>

					{isVisible.topDownloadPanel &&
						<BrandDownloadPanel
							linkUrl={downloadLinkUrl}
							fileSize={downloadFileSize}
							title={downloadTitle}
							classNames={{
								block: s.downloadPanel,
							}}
						/>
					}
				</div>

				<div className={cn(s.content, contentClassName)}>
					{children}
				</div>

				{isVisible.bottomDownloadPanel &&
					<BrandDownloadPanel
						linkUrl={downloadLinkUrl}
						fileSize={downloadFileSize}
						title={downloadTitle}
						onClick={onDownloadButtonClick}
					/>
				}
			</div>
		);
	}

}
